import(/* webpackMode: "eager" */ "/app/src/app/search/page.tsx");
